var _defs, _polygon, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _polygon3, _polygon4, _rect8, _ellipse, _path8, _path9, _path10, _rect9, _rect10, _rect11, _rect12, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse2, _ellipse3, _path29;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetectFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b65f622f-853e-450a-b3c6-fb36327b0801",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 897,
    height: 697.83547,
    viewBox: "0 0 897 697.83547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b6650c28-d27b-462d-a47d-3aa47119cf7d",
    x1: 369,
    y1: 646,
    x2: 369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4735,
    stopColor: "#f0f0f0",
    stopOpacity: 0.7
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "futuristic_interface") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "369 646 706.75 0 31.25 0 369 646 706.75 0 31.25 0 369 646",
    opacity: 0.4,
    fill: "url(#b6650c28-d27b-462d-a47d-3aa47119cf7d)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 571,
    width: 92,
    height: 92,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M525.5,469.08226c-95.94385,0-174-78.05615-174-174s78.05615-174,174-174c95.94434,0,174,78.05616,174,174S621.44434,469.08226,525.5,469.08226Zm0-343c-93.187,0-169,75.813-169,169s75.813,169,169,169c93.18652,0,169-75.813,169-169S618.68652,126.08226,525.5,126.08226Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M525.5,427.08226c-72.78516,0-132-59.21484-132-132s59.21484-132,132-132,132,59.21485,132,132S598.28516,427.08226,525.5,427.08226Zm0-261a129,129,0,1,0,129,129A129.14608,129.14608,0,0,0,525.5,166.08226Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M525.5,337.08226a42,42,0,1,1,42-42A42.0478,42.0478,0,0,1,525.5,337.08226Zm0-82a40,40,0,1,0,40,40A40.04521,40.04521,0,0,0,525.5,255.08226Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M515.5,245.08226a41,41,0,0,0-41,41h41Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#6c63ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M474.5,304.08226a41,41,0,0,0,41,41v-41Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#6c63ff",
    opacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M532.5,245.08226v41h41A41,41,0,0,0,532.5,245.08226Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#6c63ff",
    opacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M532.5,341.08226a41,41,0,0,0,41-41h-41Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#6c63ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "415.406 144.923 413.594 144.077 434.863 98.5 572.5 98.5 572.5 100.5 436.137 100.5 415.406 144.923",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 55,
    width: 78,
    height: 6,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 68,
    width: 78,
    height: 6,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 81,
    width: 78,
    height: 6,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 385,
    width: 78,
    height: 6,
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 398,
    width: 78,
    height: 6,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 335,
    y: 411,
    width: 78,
    height: 6,
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "446 428 444 428 444 272.286 421.15 235.528 422.85 234.472 446 271.714 446 428",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "304 428 302 428 302 271.714 325.151 234.472 326.849 235.528 304 272.286 304 428",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    y: 661.99977,
    width: 897,
    height: 2,
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 689.86344,
    cy: 456.19163,
    rx: 61.54769,
    ry: 15.57231,
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M817.26344,350.01389s-.74154,29.66154-6.67385,33.36923,10.38154,14.83077,10.38154,14.83077l24.47077-4.44923,15.57231-19.28s-11.12308-13.34769-7.41539-24.47077Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#ffb6b6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M817.26344,350.01389s-.74154,29.66154-6.67385,33.36923,10.38154,14.83077,10.38154,14.83077l24.47077-4.44923,15.57231-19.28s-11.12308-13.34769-7.41539-24.47077Z",
    transform: "translate(-151.5 -101.08226)",
    opacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M783.8942,378.93389s-12.60615,5.19077-13.34769,22.98769,0,69.70462,0,69.70462l21.50462-1.48308Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#f0f0f0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 890.6757,
    y: 564.91076,
    width: 1.48318,
    height: 200.88475,
    transform: "translate(-232.0121 23.27841) rotate(-7.63657)",
    fill: "#2f2e41"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 861.38508,
    y: 568.39837,
    width: 1.48287,
    height: 197.24645,
    transform: "translate(-205.94658 -24.03837) rotate(-4.9604)",
    fill: "#2f2e41"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 684.23868,
    y: 650.89295,
    width: 227.48952,
    height: 1.48344,
    transform: "translate(-74.9162 1286.07118) rotate(-84.79038)",
    fill: "#2f2e41"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 829.42447,
    y: 534.53274,
    width: 1.4826,
    height: 231.1881,
    transform: "translate(-174.32171 -70.83643) rotate(-2.05896)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M763.13113,504.25389s-85.27693,5.93231-71.1877,34.11078,82.31077,75.63692,82.31077,75.63692,12.60616,2.96616,14.83077,3.70769,36.33539-22.24615,36.33539-22.24615-20.76308-12.60615-30.40308-14.83077-37.07692-25.95385-37.07692-25.95385l77.12-19.28-45.23385-38.56Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M831.35267,522.79236s-48.94154,69.23273-39.30154,96.53483S795.01728,737.097,795.01728,737.097s36.33539,11.86462,36.33539,0,10.38154-95.65846,0-123.83693c0,0,2.22461-17.79692,8.15692-20.76307S866.205,562.0939,866.205,562.0939s22.24615-10.38154,19.28-20.02154S831.35267,522.79236,831.35267,522.79236Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M865.46344,334.44158A29.66154,29.66154,0,1,1,835.8019,304.78,29.64857,29.64857,0,0,1,865.46344,334.44158Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#ffb6b6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M855.0819,364.10312s44.49231,18.53846,37.81846,42.26769-20.76307,126.06155-42.26769,126.06155-66.73847-11.86462-69.70462-16.31385,11.12308-94.91693,11.12308-94.91693,17.03773-55.15866,23.34963-50.567c0,0-4.06963,23.87164,17.435,17.93933S855.0819,364.10312,855.0819,364.10312Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#f0f0f0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M816.28746,364.10312s-37.584,5.19077-36.101,13.34769l-2.96615,31.14462L789.085,471.6262l-1.48307,20.76308-36.33539,12.60615,43.00923,12.60616s17.79693-85.27693,14.83077-101.59078S816.28746,364.10312,816.28746,364.10312Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M853.92988,361.47662s40.45356,23.38958,43.41971,30.805,0,78.60308,0,78.60308,5.19077,66.73847-9.64,83.79385c0,0,5.19077-8.89846-22.24615-8.89846s-40.78462-5.19077-41.52616-5.93231-14.83077,0-14.83077,0-5.19077-106.04,11.86462-125.32S856.48556,372.93936,853.92988,361.47662Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M774.99574,517.60159v8.89846S745.3342,553.937,757.19882,561.35236,792.05113,534.657,792.05113,534.657l2.79373-19.82038Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#ffb6b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M774.99574,517.60159v8.89846S745.3342,553.937,757.19882,561.35236,792.05113,534.657,792.05113,534.657l2.79373-19.82038Z",
    transform: "translate(-151.5 -101.08226)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M786.86036,611.777l8.15692,11.86461s-28.17846,43.00923-15.57231,47.45847,67.48-48.94154,66.73847-53.39078-26.69539-22.24615-26.69539-22.24615Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M797.2419,731.16467l-6.67385,29.66154S764.6142,794.937,776.47882,797.90314s38.56-.74154,42.26769-8.89846,8.15693-19.28,14.08924-28.17847-5.19077-29.66154-5.19077-29.66154Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M775.73728,458.27851l-5.19077,13.34769,2.22462,51.16616s18.53846-7.41539,24.47077,0l-5.19077-51.16616-8.15693-13.34769Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#f0f0f0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M803.17421,522.79236,789.085,527.24159s-54.87384,17.79692-30.40307,30.40308,38.56-8.15693,38.56-8.15693l9.64-7.41538Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#ffb6b6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M886.22652,394.5062s-20.02154,9.64-22.9877,35.59385-6.67384,60.06461-6.67384,60.06461l-37.07693,24.47077s-25.35557-1.00613-21.57624,8.3954,4.52086,29.42307,11.1947,26.45691,16.31385-20.76307,25.95385-21.50461,49.68308-16.31385,54.13231-34.11077,21.50462-77.86155,14.08923-86.76S892.15882,390.79851,886.22652,394.5062Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#f0f0f0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M807.72963,315.53439s-11.86793-.18007-14.455,4.40382-1.73733,7.90776,1.77072,7.9915,19.84273-9.54028,19.84273-9.54028Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M807.72963,315.53439s-11.86793-.18007-14.455,4.40382-1.73733,7.90776,1.77072,7.9915,19.84273-9.54028,19.84273-9.54028Z",
    transform: "translate(-151.5 -101.08226)",
    opacity: 0.1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M859.60518,330.70972l-8.11712,7.03281s-7.70687,7.14583-18.80029-3.85562-26.78332-19.73817-33.24686-17.10507l16.477-6.93648,16.01229-.44365,18.19327,7.66089Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M865.14559,338.63636a101.03216,101.03216,0,0,0-10.18541-9.98768c-6.99642-6.00607-16.887-12.94637-27.40669-15.37683,0,0-10.55344-3.349-18.06354-.1215l14.52209-15.8615s7.84918-4.45828,11.95167-3.328c0,0,13.80112,2.9682,17.70524,6.43617.11024.0966.21115.195.30384.29118h0a10.09968,10.09968,0,0,1,6.15085,3.33215c3.55357,4.05981,9.14305,12.01729,7.93145,20.85172C866.30518,337.63168,865.14559,338.63636,865.14559,338.63636Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M857.68163,332.52944c-29.89472-25.19022-46.88638-19.712-47.05438-19.65367l-.49171-1.39907c.71475-.252,17.86717-5.895,48.502,19.91871Z",
    transform: "translate(-151.5 -101.08226)",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 853.22805,
    cy: 299.96004,
    rx: 2.96615,
    ry: 4.44923,
    transform: "translate(15.34101 787.81492) rotate(-60)",
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 860.64344,
    cy: 334.81235,
    rx: 2.22462,
    ry: 3.70769,
    transform: "translate(-190.85766 26.83769) rotate(-8.31107)",
    fill: "#ffb6b6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M835.29028,354.84869c2.84006-4.74582-1.535-6.785-1.535-6.785s-10.01077-3.64836-13.73331-5.01281c-3.73-1.357-5.46514,4.0117-5.46514,4.0117-.67482.31891-4.73844-2.78077-7.59334-5.65789a29.6728,29.6728,0,0,0,44.24021,18.39014l5.25006-12.68776C849.20771,351.93986,842.14716,354.59152,835.29028,354.84869Zm-4.54572,1.78713a7.30947,7.30947,0,0,1-6.92586,1.92056l.22983-1.24578s4.30087-.215,2.48414-1.31991a33.99815,33.99815,0,0,0-6.28081-2.29138s-1.37192-.49682.01484,1.78714l.77123.94914-.55615.9047s-4.034-2.35808-3.65592-6.444c0,0-.42254-3.71511,4.47893-1.928,4.90907,1.79456,8.44622,3.07741,8.44622,3.07741S833.86649,353.551,830.74456,356.63582Z",
    transform: "translate(-151.5 -101.08226)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetectFace);
export default __webpack_public_path__ + "static/media/detect-face.54cdabafa93e7992e794b60a6e24a458.svg";
export { ForwardRef as ReactComponent };